import axios from "axios";
import keyNames from "../../keyName";
import { apiPath } from "../../apiPath";
const { apiErrors, isLoading, userData, apiMsg, toastData, forceLogOut } =
  keyNames;
axios.defaults.withCredentials = true;
export const getByPath =
  (path, data, name, method, keyName, toast, keyTarget = null) =>
  (dispatch) => {
    let payload = null;
    dispatch({ type: name, payload, keyName: apiErrors });
    payload = keyName;
    dispatch({ type: name, payload, keyName: isLoading });
    axios[method](apiPath + path, data && data)
      .then((res) => {
        payload = res.data.data;
        if (keyName === userData && payload !== null) {
          const { token } = payload;
          if (token) {
            // sessionStorage.setItem("authToken", token);
          }
        }
        dispatch({ type: name, payload, keyName, keyTarget });
        if (toast?.success) {
          if (toast.success.description === apiMsg)
            toast.success.description = res.data.message;
          payload = toast.success;
          dispatch({ type: name, payload, keyName: toastData });
        }
      })
      .catch((error) => {
        payload = error.response?.data;
        if (payload?.data?.logOut) {
          payload = payload.data.logOut;
          dispatch({ type: name, payload, keyName: forceLogOut });
        } else if (payload?.message === "Not authorized to access this route") {
          dispatch({ type: name, payload: true, keyName: forceLogOut });
        }
        dispatch({ type: name, payload, keyName: apiErrors });
        if (toast?.error) {
          if (toast.error.description === apiMsg)
            toast.error.description = payload?.message || "Something went wrong";
          payload = toast.error;
          dispatch({ type: name, payload, keyName: toastData });
        }
      })
      .finally(() => {
        payload = "noLoading";
        dispatch({ type: name, payload, keyName: isLoading });
      });
  };
